import PropTypes from 'prop-types';
import React from 'react';

import StateLinksCard from './StateLinksCard';

const complianceLinks = [
  {
    title: 'New Law Alerts',
    href: '/compliance/regulatory-changes/new-law-alert/[slug]',
  },
  {
    title: 'Enacted Law Bulletins',
    href: '/compliance/regulatory-changes/enacted-law-bulletin/[slug]',
  },
  {
    title: 'Adopted Regulation Bulletins',
    href: '/compliance/regulatory-changes/adopted-regulation-bulletin/[slug]',
  },
  {
    title: 'State Filing Guide',
    href: '/compliance/state-filings/state-filing-guide/[slug]',
  },
];

function ComplianceLinks({ stateCode }) {
  return (
    <StateLinksCard
      category="Compliance"
      iconId={39}
      links={complianceLinks}
      stateCode={stateCode}
    />
  );
}

ComplianceLinks.propTypes = {
  stateCode: PropTypes.string.isRequired,
};

export default ComplianceLinks;
